import cn from 'classnames'
import { useDispatch, useSelector } from 'react-redux'

import { ChangePasswordForm } from '@src/pages/ChangePassword/ChangePasswordForm'
import { IndividualsPanel } from '@src/components/IndividualsPanel/IndividualsPanel'
import style from '@src/pages/ChangePassword/ChangePassword.module.scss'
import { Footer } from '@src/components/Footer/Footer'
import {
  selectChangePasswordSuccess,
  selectIsLoading,
} from '@src/store/ducks/auth/selectors'
import { ReturnBtn } from '@src/components/Button/ReturnBtn'
import { Modal } from '@src/components/common/Modal/Modal'
import { NavLink } from 'react-router-dom'
import { Button } from '@src/components/Button/Button'
import { useEffect } from 'react'
import { setPageTitle } from '@src/store/ducks/app/reducer'
import { AppDispatch } from '@src/store/store'

export const ChangePassword = () => {
  const dispatch = useDispatch<AppDispatch>()
  const changePasswordSuccess = useSelector(selectChangePasswordSuccess)
  const isLoading = useSelector(selectIsLoading)

  useEffect(() => { dispatch(setPageTitle('Смена личного пароля')) }, [dispatch])

  return (
    <div>
      <IndividualsPanel />
      <div className={cn(style.changePasswordContainer, 'container')}>
        <ReturnBtn type="secondary">Вернуться</ReturnBtn>
        <div className={style.changePasswordBlock}>
          <h2 className={style.mainTitle}>Смена личного пароля</h2>
          <ChangePasswordForm isLoading={isLoading} />
        </div>
        <Modal isOpen={changePasswordSuccess}>
          <h3 className={style.successTitle}>
            Ваш пароль был
            <span className="blue"> успешно </span>
            изменен!
          </h3>
          <NavLink to="/my-profile">
            <Button className={style.successBtn} type="primary">
              В личный кабинет
            </Button>
          </NavLink>
        </Modal>
      </div>
      <Footer />
    </div>
  )
}
